module.exports = __webpack_public_path__ + "img/doors_red.bdabe43c.svg";